import { useState, useEffect } from "react";

const useStravaStats = () => {
  const [totalKm, setTotalKm] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchStats = async () => {
      try {
        const clientId = process.env.REACT_APP_STRAVA_CLIENT_ID;
        const clientSecret = process.env.REACT_APP_STRAVA_CLIENT_SECRET;
        const refreshToken = process.env.REACT_APP_STRAVA_REFRESH_TOKEN;
        const athleteId = process.env.REACT_APP_STRAVA_ATHLETE_ID;

        if (!clientId || !clientSecret || !refreshToken || !athleteId) {
          throw new Error("Missing Strava credentials");
        }

        // Refresh the access token (expires every 6 hours)
        const tokenRes = await fetch("https://www.strava.com/oauth/token", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            client_id: clientId,
            client_secret: clientSecret,
            refresh_token: refreshToken,
            grant_type: "refresh_token",
          }),
        });

        if (!tokenRes.ok) throw new Error("Failed to refresh Strava token");
        const { access_token } = await tokenRes.json();

        // Fetch all-time athlete stats
        const statsRes = await fetch(
          `https://www.strava.com/api/v3/athletes/${athleteId}/stats`,
          { headers: { Authorization: `Bearer ${access_token}` } }
        );

        if (!statsRes.ok) throw new Error("Failed to fetch Strava stats");
        const stats = await statsRes.json();

        const totalMeters =
          (stats.all_run_totals?.distance || 0) +
          (stats.all_ride_totals?.distance || 0) +
          (stats.all_swim_totals?.distance || 0);

        setTotalKm(Math.round(totalMeters / 1000));
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchStats();
  }, []);

  return { totalKm, loading, error };
};

export default useStravaStats;
